<template>
  <div class="contact home">
    <div class="header d-none d-sm-block">
      <FloatingLogo></FloatingLogo>
      <div class="header-slider"></div>
    </div>

    <div class="header mobile d-xs-block d-sm-none">
      <FloatingLogo></FloatingLogo>
      <div class="header-slider"></div>
    </div>

    <div class="body text-left">
      <div class="boxed container">
        <div class="title">
          <h2>Contáctanos</h2>
        </div>
        <div class="content card-like">
            <form v-if="!this.formSent" class="form-row row">

              <b-form-group
                class="form-group col-12 col-sm-4"
                :state="!$v.name.$error"
                :invalid-feedback="`Este campo es requerido y debe tener un mínimo de ${$v.name.$params.minLength.min} caracteres`"
              >
                <label for="nameInput">Nombre (*)</label>
                <b-form-input id="nameInput"
                              type="text"
                              class="form-control"
                              :state="!$v.name.$anyDirty ? null : !$v.name.$error"
                              v-model.trim="$v.name.$model"
                              placeholder="Nombre y Apellido">
                </b-form-input>
              </b-form-group>

              <b-form-group
                class="form-group col-12 col-sm-4"
                :state="!$v.phone.$error"
                invalid-feedback="Teléfono Inválido"
              >
                <label for="phoneInput">Teléfono (opcional)</label>
                <the-mask
                  :id="`phoneInput`"
                  :placeholder="`(0XXX) XXX-XXXX`"
                  v-model.trim="$v.phone.$model"

                  :class="`form-control` + ($v.phone.$error ? ' is-invalid' : (!$v.phone.$invalid ? ' is-valid' : ''))"
                  :mask="['(####) ###-####']" />
              </b-form-group>

              <b-form-group
                class="form-group col-12 col-sm-4"
                :state="!$v.email.$error"
                invalid-feedback="Correo inválido - Este campo es obligatorio"
              >
                <label for="emailInput">Correo Electrónico (*)</label>
                <b-form-input id="emailInput"
                              type="text"
                              class="form-control"
                              :state="!$v.email.$anyDirty ? null : !$v.email.$error"
                              v-model.trim="$v.email.$model"
                              placeholder="nombre@dominio.com">
                </b-form-input>
              </b-form-group>

              <b-form-group
                class="form-group col-12"
                :state="!$v.subject.$error"
                invalid-feedback="Este campo es obligatorio"
              >
                <label for="subjectInput">Asunto (*)</label>
                <b-form-input id="subjectInput"
                              type="text"
                              class="form-control"
                              :state="!$v.subject.$anyDirty ? null : !$v.subject.$error"
                              v-model.trim="$v.subject.$model"
                              placeholder="">
                </b-form-input>
              </b-form-group>

              <b-form-group
                :class="`form-group col-12`"
                :state="!$v.message.$error"
                :invalid-feedback="`Este campo es requerido y debe tener un mínimo de ${$v.message.$params.minLength.min} caracteres`"
              >
                <label for="messageInput">Mensaje (*)</label>
                <b-form-textarea
                  id="messageInput"
                  type="text"
                  class="form-control"
                  v-model.trim="$v.message.$model"
                  :state="!$v.message.$anyDirty ? null : !$v.message.$error"
                  placeholder="Mensaje a enviar">
                </b-form-textarea>
                <small class="form-text text-muted">{{ 150 - message.length }} caracteres restantes</small>
              </b-form-group>

              <div v-if="sendError === true" class="text-right w-100">
                <small
                  class="form-text text-red">
                  Ocurrió un error al enviar tu mensaje, por favor intenta nuevamente.
                </small>
              </div>

              <div class="col-12 btn-submit-container text-right w-100">
                <b-button v-on:click="onSubmitButtonClick" :variant="`primary`" >Enviar mensaje</b-button>
              </div>

            </form>

          <div v-else class="row">
            <b-col cols="12" class="message-sent">
              Tu mensaje fué enviado con éxito, lo revisaremos
              y nos pondremos en contacto a la brevedad posible.
            </b-col>
          </div>

        </div>
        <div class="bottom-spacer"></div>

      </div>
      <Footer></Footer>
    </div>

    <loading :active.sync="this.$store.state.messageFormSubmitting"
             :can-cancel="false"
             :is-full-page="true"
             color="#f15b2b"
             background-color="#8a8a8a"
             loader="dots"
    ></loading>

  </div>
</template>

<script>
  import Footer from "@/components/Footer";

  import { validationMixin } from 'vuelidate'
  import { required, minLength, email } from "vuelidate/lib/validators";

  import { TheMask } from 'vue-the-mask'
  import JQuery from "jquery";
  import Loading from 'vue-loading-overlay';
  import FloatingLogo from "../components/FloatingLogo";

  export default {
    name: "FAQ",
    components: {
      FloatingLogo,
      Footer,
      TheMask,
      Loading
    },
    mixins: [validationMixin],
    data() {
      return {
        formSent: false,
        name: '',
        phone: '',
        email: '',
        subject: '',
        message: ''
      };
    },
    validations() {
      return {
        name: {
          required,
          minLength: minLength(3)
        },
        phone: {
          minLength: minLength(11)
        },
        email: {
          required,
          email
        },
        subject: {
          required,
          minLength: minLength(6)
        },
        message: {
          required,
          minLength: minLength(15)
        }
      }
    },
    watch: {
      '$route': function (id) {
        this.resetFields();
      },
      '$store.state.messageFormSubmitting': function (val) {
        if (val === false) {
          if (this.$store.state.messageFormSubmitResult &&
            this.$store.state.messageFormSubmitResult.success === true) {
            console.log("Message form sucessfully sent!");

            this.onFormSubmitSuccess();

          } else if (this.$store.state.messageFormSubmitResult &&
            this.$store.state.messageFormSubmitResult.success === false) {
            console.log("Message form send error")
            console.log(this.$store.state.messageFormSubmitResult.error)

            this.onFormSubmitError();
          }
        }
      },
    },
    computed: {
      sendError: function () {
        return this.$store.state.messageFormSubmitResult !== null
          && this.$store.state.messageFormSubmitResult.success === false;
      }
    },
    methods: {
      onSubmitButtonClick: function () {
        console.log("Submit on click!", this.$v);
        this.$v.$touch();

        if (this.$v.$anyError) {
          console.log("Display Error");
          JQuery("html").scrollTop = JQuery(".is-invalid").offsetTop
        } else {
          this.sendMessageSubmit()
        }
      },

      sendMessageSubmit: function() {
        this.$store.dispatch({
          type: "action",
          actionType: this.$types.SUBMIT_SEND_MESSAGE,
          value: {
            name: this.name,
            phone: this.phone,
            email: this.email,
            subject: this.subject,
            message: this.message
          }
        });
      },

      onFormSubmitSuccess: function () {
        this.formSent = true;
        this.resetFields();
      },

      onFormSubmitError: function () {
        this.submitError = true;
      },

      resetFields: function() {
        this.name = "";
        this.email = "";
        this.phone = "";
        this.subject = "";
        this.message = "";
        this.sendError = false;
        this.$store.commit("messageFormSubmitting", false)
        this.$store.commit("messageFormSubmitResult", null)
      }
    }
  };
</script>
<style>
  .contact .body .text-red {
    color: red;
  }
</style>
